import Modal from "react-bootstrap/Modal";
import React, {useEffect, useState} from "react";

const ModalChangeJumlah = ({show, onHide, drug, detail, onSave}) => {

  const [qty, setQty] = useState(detail?.qty ?? 0)

  return (
    <Modal
      show={ show }
      onHide={() => {
        onHide()
      }}
      size={'md'}
      centered>
      <Modal.Body className={'pb-0'}>
        <h4 className={'mb-0'}>Ganti Jumlah</h4>
      </Modal.Body>
      <Modal.Body>
        <div className={'row'}>
          <div className={'col-12'}>
            <h5>OBAT: {detail?.drug?.name ?? ''}</h5>
            <h5>BATCH: {detail?.drug_in_detail[0]?.batch_number ?? ''}</h5>
            <h5>JUMLAH LAMA: {detail?.qty ?? 0}</h5>
            <div className="form-group">
              <h5>JUMLAH BARU</h5>
              <input type="text" className="form-control form-control-sm" value={qty} onChange={(e) => setQty(e.target.value)}></input>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className={'pt-0'}>
        <button type={'button'} className={'btn btn-success'} onClick={() => onSave(qty)}>
          Simpan
        </button>
        <button type={'button'} className={'btn btn-danger'} onClick={onHide}>
          Tutup
        </button>
      </Modal.Footer>
    </Modal>
  )
}

export default ModalChangeJumlah